import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "nav-job-icon" }
const _hoisted_2 = {
  key: 2,
  class: "q-pa-md"
}

import { computed, ref } from "vue";
import { JobSchema } from "@/types";
import { getVersionApiStore, jobStore, logStore } from "@/hooks";
import { navigateTo, Routes } from "@/router";
import { Typography, Icon, List, ListItem } from "@/components/common";


/**
 * Displays the user's notifications.
 */
const __default__ = {
  name: "Notifications",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const viewedMessages = ref(0);
const open = ref(false);

const notifications = computed(() => logStore.notifications);
const newNotifications = computed(() =>
  Math.max(notifications.value.length - viewedMessages.value, 0)
);

const inProgressJobs = computed(() => jobStore.inProgressJobs);
const recentJobs = computed(() => jobStore.recentJobs);
const displayInProgressJobs = computed(() => inProgressJobs.value.length > 0);
const displayRecentJobs = computed(() => recentJobs.value.length > 0);

const displayUpdates = computed(
  () => newNotifications.value > 0 || inProgressJobs.value.length > 0
);
const updates = computed(
  () => newNotifications.value + inProgressJobs.value.length
);

const color = computed(() => (inProgressJobs.value ? "primary" : "secondary"));

/**
 * Sets all messages to viewed on open.
 */
function handleOpen() {
  open.value = true;
  viewedMessages.value = notifications.value.length;
}

/**
 * WHen a job is clicked, open the project if the job is completed, or open the upload status page.
 * @param job - The job to open.
 */
function handleClickJob(job: JobSchema) {
  if (job.completedEntityId) {
    getVersionApiStore.handleLoad(job.completedEntityId);
  } else {
    navigateTo(Routes.UPLOAD_STATUS);
  }
}

return (_ctx: any,_cache: any) => {
  const _component_q_circular_progress = _resolveComponent("q-circular-progress")!
  const _component_q_badge = _resolveComponent("q-badge")!
  const _component_q_menu = _resolveComponent("q-menu")!

  return (_openBlock(), _createBlock(_unref(ListItem), {
    to: "",
    title: "Notifications",
    clickable: "",
    tooltip: "Notifications",
    onClick: handleOpen
  }, {
    icon: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (displayInProgressJobs.value)
          ? (_openBlock(), _createBlock(_component_q_circular_progress, {
              key: 0,
              color: color.value,
              indeterminate: "",
              size: "md"
            }, null, 8, ["color"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", null, [
        _createVNode(_unref(Icon), {
          variant: "notification",
          size: "sm",
          color: "text"
        }),
        (displayUpdates.value)
          ? (_openBlock(), _createBlock(_component_q_badge, {
              key: 0,
              color: color.value,
              rounded: "",
              floating: "",
              label: updates.value,
              class: "nav-job-badge"
            }, null, 8, ["color", "label"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode(_component_q_menu, {
        modelValue: open.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((open).value = $event))
      }, {
        default: _withCtx(() => [
          (displayRecentJobs.value)
            ? (_openBlock(), _createBlock(_unref(List), {
                key: 0,
                class: "nav-notifications q-pa-sm"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Typography), {
                    variant: "caption",
                    value: "Jobs"
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(recentJobs.value, (job) => {
                    return (_openBlock(), _createBlock(_unref(ListItem), {
                      key: job.id,
                      dense: "",
                      clickable: "",
                      title: job.name,
                      subtitle: job.steps[job.currentStep],
                      onClick: ($event: any) => (handleClickJob(job))
                    }, {
                      icon: _withCtx(() => [
                        (job.status === 'IN_PROGRESS')
                          ? (_openBlock(), _createBlock(_component_q_circular_progress, {
                              key: 0,
                              color: "secondary",
                              value: job.currentProgress,
                              size: "sm"
                            }, null, 8, ["value"]))
                          : (job.status === 'COMPLETED')
                            ? (_openBlock(), _createBlock(_unref(Icon), {
                                key: 1,
                                variant: "job-complete",
                                color: "primary"
                              }))
                            : (job.status === 'FAILED')
                              ? (_openBlock(), _createBlock(_unref(Icon), {
                                  key: 2,
                                  variant: "job-fail",
                                  color: "error"
                                }))
                              : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["title", "subtitle", "onClick"]))
                  }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (notifications.value.length > 0)
            ? (_openBlock(), _createBlock(_unref(List), {
                key: 1,
                class: "nav-notifications q-pa-sm q-mb-sm"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Typography), {
                    variant: "caption",
                    value: "Notifications"
                  }),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(notifications.value, (item) => {
                    return (_openBlock(), _createBlock(_unref(ListItem), {
                      key: item.message,
                      dense: "",
                      title: item.message
                    }, {
                      icon: _withCtx(() => [
                        (item.type === 'success')
                          ? (_openBlock(), _createBlock(_unref(Icon), {
                              key: 0,
                              variant: "save",
                              color: "added"
                            }))
                          : _createCommentVNode("", true),
                        (item.type === 'error')
                          ? (_openBlock(), _createBlock(_unref(Icon), {
                              key: 1,
                              variant: "error",
                              color: "removed"
                            }))
                          : _createCommentVNode("", true),
                        (item.type === 'warning')
                          ? (_openBlock(), _createBlock(_unref(Icon), {
                              key: 2,
                              variant: "warning",
                              color: "warning"
                            }))
                          : _createCommentVNode("", true),
                        (item.type === 'info')
                          ? (_openBlock(), _createBlock(_unref(Icon), {
                              key: 3,
                              variant: "logs",
                              color: "modified"
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 2
                    }, 1032, ["title"]))
                  }), 128))
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (notifications.value.length === 0 && !displayRecentJobs.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                _createVNode(_unref(Typography), { value: "There are no notifications in the current session." })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}
}

})